import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExpenseSkipped = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 17,
	viewBox: "0 0 17 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: .0703125,
		y: .373047,
		width: 15.9963,
		height: 16,
		rx: 7.99817,
		fill: "#777777"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M11.2686 8.33203L5.26993 8.33203",
		stroke: "white",
		strokeWidth: .799817,
		strokeLinecap: "square",
		strokeLinejoin: "round"
	})]
});
export default SvgExpenseSkipped;
